type TrackFn = (label: string, payload?: Record<string, unknown>) => unknown;

let trackEventFn: TrackFn | null = null;

export const initializeTracking = (fn: TrackFn): void => {
  trackEventFn = fn;
};

/** Sends the event; returns the request when there is one. */
export const track = (
  label: string,
  payload: Record<string, unknown> = {},
): unknown => {
  if (!trackEventFn) {
    console.warn("Tracking not initialized");
    return;
  }
  return trackEventFn(label, payload);
};

/** Runs `send` and waits for it, for at most `timeoutMs`; never throws. */
export const settleWithin = async (
  send: () => unknown,
  timeoutMs = 1000,
): Promise<void> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const sending = async () => send();
  await Promise.race([
    sending().catch(() => undefined),
    new Promise((resolve) => {
      timer = setTimeout(resolve, timeoutMs);
    }),
  ]);
  clearTimeout(timer);
};

/**
 * Tracks an event right before a full page navigation, which would cancel
 * the request: waits for it to be sent, for at most `timeoutMs`.
 */
export const trackBeforeNavigating = async (
  label: string,
  payload: Record<string, unknown>,
  timeoutMs = 1000,
): Promise<void> => {
  await settleWithin(() => track(label, payload), timeoutMs);
};
